import React from "react";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";

const Whoops = ({ error, resetErrorBoundary }) => {
  return (
    <Container>
      <Typography variant="h4">
        Whoops! Something went wrong, contact administrator!!!
      </Typography>
      <pre>{error.message}</pre>
    </Container>
  );
};

export default Whoops;
